import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import CKEditor from "@ckeditor/ckeditor5-vue2";
Vue.config.productionTip = false;
Vue.use(CKEditor);
import i18n from "@/i18n/index";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);
new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App),
}).$mount("#app");
